<template>
  <header class="bg-blue-600 text-white shadow-lg">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center h-16">
        <!-- Left Side: Logo -->
        <div class="flex-shrink-0">
          <router-link to="/" class="text-2xl font-bold hover:opacity-80 transition-opacity">
            <span class="handwriting-font">EasyMarks</span> AI
          </router-link>
        </div>

        <!-- Right Side Container -->
        <div class="hidden md:flex items-center space-x-4">
          <!-- Navigation Links Group -->
          <div class="flex items-center space-x-4">
            <router-link to="/testsoverview" class="flex items-center px-3 py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition-colors" active-class="bg-blue-700">Tests</router-link>
            <router-link to="/profile" class="flex items-center px-3 py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition-colors" active-class="bg-blue-700">Profile</router-link>
            <button @click="logout" class="flex items-center px-3 py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition-colors">Logout</button>
          </div>

          <!-- Vertical Separator -->
          <div class="w-px h-6 bg-blue-500"></div>

          <!-- Credits Display (Now on the far right) -->
          <div class="flex items-center text-sm font-medium">
            <svg class="h-5 w-5 mr-2 text-yellow-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v.01"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18.5A6.5 6.5 0 1012 5.5a6.5 6.5 0 000 13z"></path></svg>
            <span>Credits: {{ userStore.formattedCredits }}</span>
          </div>
        </div>

        <!-- Mobile Menu (omitted for brevity, no changes needed) -->
      </div>
    </div>
    <!-- Mobile Menu div (omitted for brevity, no changes needed) -->
  </header>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { nextTick } from 'vue'

const router = useRouter()
const userStore = useUserStore()

const logout = async () => {
  userStore.clearUser()
  await nextTick() // lets the App.vue watcher disconnect WS cleanly
  router.replace('/') // go to front page instead of /login
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Indie+Flower&display=swap');
.handwriting-font { font-family: 'Indie Flower', cursive; }
.router-link-exact-active { background-color: #2563eb; }
</style>
